export default __webpack_public_path__ + "static/media/ic_remove.0b7e9581.svg";